import { Get, Post, Put } from '../../api/axiosCoreConfig';

export const getClinics = (namespace) => Get(`/clinic/?namespace=${namespace}`);
export const createClinic = (body) => Post('/clinic', body);
export const updateClinic = (clinicId, body) => Put(`clinic/${clinicId}`, body);
